import React, { useEffect, useState } from 'react';
import axios from "axios";
import DataTable from 'react-data-table-component';
import { carenavigatorBreaksList, getCareNavigators, fetch_supervisors_list } from '../../../services/medengage/Service';
import { exportTableData, LoaderLoader } from '../../utils/CommonLibrary';
import { Modal } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { decryptData } from '../../utils/Utils';
import moment from "moment";
import CalendarDatePicker from '../../componenents/CalendarDatePicker';
import { formatDate } from '../../utils/CommonLibrary';
import { format } from 'date-fns';
import { MultiSelect } from 'react-multi-select-component';
import { CustomLoader } from '../../utils/CommonLibrary';
import BackendDrivenDataTable from '../../cn/components/common/BackendDrivenDataTable';

function CNBreaksPlans() {
    const storedDates = localStorage.getItem('selectedDates') ? JSON.parse(decryptData(localStorage.getItem('selectedDates'))) : '';
    const [selectedCN, setSelectedCN] = useState("");
    const [selectedSupervisor, setSelectedSupervisor] = useState("");
    const [startDate, setStartDate] = useState(
        storedDates && storedDates.length === 4 ? moment(storedDates[0]) : moment()
    );
    const [endDate, setEndDate] = useState(
        storedDates && storedDates.length === 4 ? moment(storedDates[1]) : moment()
    );

    const [searchQuery, setSearchQuery] = useState('');
    const [selectedProgram, setSelectedProgram] = useState('');
    const [selectedCondition, setSelectedCondition] = useState('');
    const [programList, setProgramList] = useState([]);
    const [conditionList, setConditionList] = useState([]);
    const [newMembersDisenrollList, setNewMembersDisenrollList] = useState([])
    const [data, setData] = useState([]);
    const [isNewLoading, setIsNewLoading] = useState(false);
    const [carenavigatorsList, setCarenavigatorsList] = useState([]);
    const [supervisorList, setSupervisorList] = useState([]);

    const [options, setOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);

    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState("breakStart");
    const [sortDirection, setSortDirection] = useState('desc');
    const [download, setDownload] = useState('N');

    useEffect(() => {
        fetchListDetails();
    }, [page, perPage, sortColumn, sortDirection, searchQuery, startDate, endDate, selectedCN, selectedSupervisor, download]);

    useEffect(() => {
        getCareNavigatorsList();
    }, [selectedSupervisor])
    useEffect(() => {
        fetchSuperisorsList();
    }, []);
    const getCareNavigatorsList = async () => {
        setOptions([]);
        setSelectedOptions([])
        await getCareNavigators(selectedSupervisor)
            .then((response) => {
                if (response.data.code === 200) {
                    const carenavigators = response.data.data.users;
                    setCarenavigatorsList(carenavigators);
                    const formattedOptions = carenavigators.map((item) => ({
                        label: item.userName,
                        value: item.id
                    }));
                    setOptions(formattedOptions);
                }
            }).catch(function (error) {
                console.log(error);
            });
    };

    const fetchSuperisorsList = async () => {
        await fetch_supervisors_list()
            .then((res) => {
                setSupervisorList(res.data.data.supervisors);
            });
    }

    const fetchListDetails = async () => {
        try {
            setIsNewLoading(true);
            carenavigatorBreaksList(searchQuery, startDate, endDate, selectedCN, selectedSupervisor,
                page, perPage, sortColumn, sortDirection, download)
                .then((response) => {
                    if (response.data.code == 200) {
                        if (download == "N") {
                            setData(response.data.data.logs);
                            setTotalRows(response.data.data.totalRows);
                        } else {
                            handleExport(response.data.data.logs);
                            setDownload('N');
                        }
                    }
                    setIsNewLoading(false);
                });
        } catch (error) {
            console.error(error);
        }
        finally {
        }
    };

    const handleChange = (selected) => {
        setSelectedOptions(selected);
        const valueArray = selected.map(option => option.value).join(',')

        setSelectedCN(valueArray);
    };

    const handleDateChange = ({ start, end }) => {
        setStartDate(start);
        setEndDate(end);
    };

    const columns = [
        {
            name: 'CareNavigator Name',
            selector: row => row.cnName,
            sortable: true,
        },
        {
            name: 'Supervisor',
            selector: row => row.supervisorName,
            sortable: true,
        },
        {
            name: 'Break Starts',
            selector: row => row.breakStartTime,
            sortable: true,
        },
        {
            name: 'Break Ends',
            selector: row => row.breakEndTime,
            sortable: true,
        },
        {
            name: 'Reason',
            selector: row => row.reason,
            sortable: false,
        }
    ];




    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#D4E6EF',
                fontWeight: '500',
                fontSize: '14px',
                whiteSpace: 'normal',
            },
        },
        rows: {
            style: {
                whiteSpace: 'normal',
            },
        },
        cells: {
            style: {
                whiteSpace: 'normal',
            },
        },
    };

    const handleClear = () => {
        setSearchQuery('');
        setSelectedProgram('');
        setSelectedCondition('');
    };

    const filteredData = newMembersDisenrollList.filter(user => {
        const matchesSearchQuery =
            user.memberName.toLowerCase().includes(searchQuery.toLowerCase()) || user.membershipNo == searchQuery;

        const matchesProgram = selectedProgram === 'All' || user.carePrograms.toLowerCase() === selectedProgram.toLowerCase();
        const matchesCondition = selectedCondition === 'All' || user.chronicConditions.toLowerCase() === selectedCondition.toLowerCase();
        return matchesSearchQuery && matchesProgram && matchesCondition;
    });

    const handleExport = (data) => {

        const modifiedData = data.map(item => {
            return {
                'Date': item.logDate,
                'CareNavigator Name': item.cnName,
                'Supervisor': item.supervisorName,
                'Total Slots': item.totalSlots,
                'Total Appointment Scheduled': item.callsTotalScheduled,
                'Completed': item.callsTotalCompleted,
                'Missed': item.callsTotalMissed,
                'Cancelled': item.callsTotalCancelled,
                'Member No-Show': item.callsTotalMemberNoShow,
                'Capacity Utilization': item.capacityUtilization,
                'Completion Rate': item.completionRate
            };
        });


        modifiedData.forEach(function (v) { delete v.disEnrollBy; delete v.logId; delete v.membershipNo; delete v.mobile; delete v.userId; });

        exportTableData("AppointmentOverview", modifiedData);
    };

    return (
        <>
            <LoaderLoader isLoading={isNewLoading} />
            <div className='container-fluid'>
                <div className="row align-items-center ">
                    <div className="col-md-4 pe-0">
                        <select className="form-select input-field-ui" id="selectedSupervisor" aria-label="Default select example" value={selectedSupervisor} onChange={(e) => setSelectedSupervisor(e.target.value)}>
                            <option value="">Select Supervisor</option>
                            {supervisorList.map(option => (
                                <option key={option.id} value={option.id}>{option.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4 px-1">
                        {/*<select className="form-select input-field-ui" id="selectedCN" aria-label="Default select example" value={selectedCN} onChange={(e) => setSelectedCN(e.target.value)}>
                            <option value="">All CareNavigators</option>
                            {carenavigatorsList.map(option => (
                                <option key={option.id} value={option.id}>{option.userName}</option>
                            ))}
                        </select>*/}
                        <MultiSelect
                            options={options}
                            value={selectedOptions}
                            onChange={handleChange}
                            labelledBy="Select"
                            hasSelectAll={false}
                            className="form-select select-input-ui select-input-ui-select"
                            disableSearch={true}
                            overrideStrings={{ selectAll: 'Select All', allItemsAreSelected: 'All items are selected', selectSomeItems: 'Select CareNavigators' }}
                            style={{ fontSize: '1rem' }}

                        />
                    </div>

                    <div className="col-md-4 ps-0">
                        <CalendarDatePicker startDate={startDate} endDate={endDate} onDateChange={handleDateChange} />
                    </div>

                    <div className="col-12 mt-3">
                    {
                isNewLoading ? <CustomLoader /> :
                    <BackendDrivenDataTable
                        data={data}
                        loading={isNewLoading}
                        totalRows={totalRows}
                        page={page}
                        perPage={perPage}
                        sortColumn={sortColumn}
                        sortDirection={sortDirection}
                        filterText={searchQuery}
                        columns={columns}
                        fetchTableData={fetchListDetails}
                        setPage={setPage}
                        setSortColumn={setSortColumn}
                        setSortDirection={setSortDirection}
                        setPerPage={setPerPage}
                    />
            }
                    </div>
                </div>
            </div>
            
        </>
    );
}

export default CNBreaksPlans